import { X, CheckCircle, Quote, Image as ImageIcon, Tag } from "lucide-react";

const ViewBlogModal = ({ blog, onClose, onClick }) => {
  if (!blog) return null;

  console.log(blog)
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl shadow-md">
          <h2 className="text-2xl font-bold">Blog Details</h2>
          <button
            onClick={onClose}
            className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div>
            <label className="text-sm font-semibold text-gray-700 uppercase">
              Main Image
            </label>
            <img
              src={blog.image}
              alt={blog.title}
              className="rounded-lg shadow-md w-full h-64 object-cover"
            />
          </div>

          <div className="bg-gray-50 rounded-lg p-6 space-y-4">
            <div>
              <label className="text-sm font-semibold text-gray-700 mb-1">
                Title
              </label>
              <h3 className="text-2xl font-bold text-gray-900">{blog.title}</h3>
            </div>

            <div>
              <label className="font-semibold text-gray-700 mb-1">
                Description
              </label>
              <p className="text-gray-600 leading-relaxed">
                {blog.description}
              </p>
            </div>

            <div>
              <label className="font-semibold text-gray-700 mb-3">
                Sub Descriptions
              </label>
              <div className="space-y-2">
                {blog.subDescriptions?.length ? (
                  blog.subDescriptions.map((item, i) => (
                    <p key={i} className="text-gray-600 leading-relaxed">
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="text-gray-500 italic">No Sub Descriptions</p>
                )}
              </div>
            </div>
          </div>

          <div className="bg-purple-50 rounded-lg p-6 space-y-3">
            <label className="font-semibold text-gray-800 flex items-center mb-2">
              <Quote className="w-6 h-6 text-purple-600 mr-2" />
              Quote Section
            </label>
            <h4 className="text-lg font-bold text-gray-900">
              {blog.quote?.title}
            </h4>
            <p className="text-gray-700 italic">{blog.quote?.text}</p>
          </div>

          <div className="bg-green-50 rounded-lg p-6 space-y-6">
            <label className="font-semibold text-gray-800 flex items-center mb-2">
              <ImageIcon className="w-5 h-5 text-green-600 mr-2" />
              Feature Section
            </label>

            <div className="space-y-4">
              {blog.feature?.image && (
                <div>
                  <label className="font-semibold text-gray-700 mb-3">
                    Feature Image
                  </label>
                  <img
                    src={blog.feature.image}
                    className="rounded-lg shadow-md w-full h-52 object-cover"
                    alt="Feature"
                  />
                </div>
              )}

              <div>
                <label className="font-semibold text-gray-700 mb-3">
                  Feature Title
                </label>
                <h4 className="text-xl font-bold text-gray-900">
                  {blog.feature?.heading}
                </h4>
              </div>

              <div>
                <label className="font-semibold text-gray-700 mb-3">
                  Feature Description
                </label>
                <p className="text-gray-700 leading-relaxed">
                  {blog.feature?.description}
                </p>
              </div>

              {blog.feature?.subDescriptions?.length > 0 && (
                <div>
                  <label className="font-semibold text-gray-700 mb-3">
                    Feature Sub Descriptions
                  </label>
                  {blog.feature.subDescriptions.map((description, index) => (
                    <p key={index} className="text-gray-700 leading-relaxed">
                      {description}
                    </p>
                  ))}
                </div>
              )}

              {blog.feature?.features?.length > 0 && (
                <div className="space-y-3">
                  <label className="font-semibold text-gray-700 mb-3">
                    Features
                  </label>
                  {blog.feature.features.map((item, i) => (
                    <p
                      key={i}
                      className="flex items-start bg-white p-3 rounded-lg shadow-sm"
                    >
                      <CheckCircle className="w-5 h-5 text-green-600 mr-3 mt-1" />
                      {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="bg-yellow-50 rounded-lg p-6 space-y-4">
            <label className="font-semibold text-gray-800 flex items-center mb-2">
              <Tag className="w-5 h-5 text-yellow-600 mr-2" />
              Labels
            </label>

            {blog.label?.length ? (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {blog.label.map((label, i) => (
                  <div
                    key={i}
                    className="flex flex-col items-center bg-white p-3 rounded-lg shadow-sm border"
                  >
                    {label.image ? (
                      <img
                        src={label.image}
                        alt={`Label ${i + 1}`}
                        className="w-20 h-20 object-cover rounded-md mb-2"
                      />
                    ) : (
                      <div className="w-20 h-20 flex items-center justify-center bg-gray-100 text-gray-400 rounded-md mb-2">
                        <ImageIcon className="w-8 h-8" />
                      </div>
                    )}
                    <p className="text-sm font-medium text-gray-700 text-center">
                      {label.text || "Untitled"}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500 italic">No Labels</p>
            )}
          </div>

          <div className="flex justify-end gap-5 border-t pt-4">
            <button
              onClick={onClose}
              className="px-8 py-3 bg-gray-600 hover:bg-gray-700 text-white rounded-lg shadow-md font-semibold"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBlogModal;